<script setup lang="ts">
import { designTokens } from '~/utils/builder/_init-design-tokens'
import { register } from '@builder.io/sdk-vue'

register('editor.settings', {
  designTokensOptional: true,
  designTokens,
})

const { locale, localeIsoCode } = useLocaleIso()

await useLazyFetch<TLink[]>(`/api/links/common`, {
  key: 'global-common-links',
  method: 'post',
  body: {
    locale: localeIsoCode.value,
  },
  default: () => [],
  watch: [locale],
})

const dir = useTextDirection()

const route = useRoute()
const error = useError()

// Error pages render inside this component too, and their `.md` URL would 404.
const markdownAlternatePath = computed(() =>
  error.value ? null : getMarkdownAlternatePath(route.path)
)

useHead({
  link: computed(() =>
    markdownAlternatePath.value
      ? [
          {
            rel: 'alternate',
            type: 'text/markdown',
            href: markdownAlternatePath.value,
          },
        ]
      : []
  ),
})

const { getCountries, getIndustries } = useRepositories().baseData

await getCountries()
await getIndustries()
</script>

<template>
  <div>
    <NuxtLoadingIndicator color="#1a56db" error-color="#c81e1e" />

    <NuxtLayout>
      <ConfigProvider :dir="dir.includes('rtl') ? 'rtl' : 'ltr'">
        <NuxtPage />

        <client-only>
          <LazyTrailDSToaster />
        </client-only>
      </ConfigProvider>
    </NuxtLayout>
  </div>
</template>
